/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import styled from 'styled-components';

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
export const SwitchWrapper = styled.div`
  margin-right: 20px;
`;

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
export const Subtext = styled.div`
  color: ${({theme}) => theme.colors.palettes.neutral[200][100]};
  font-size: ${({theme}) => theme.fontSizes.text.xSmall};
  font-weight: normal;
  margin-top: ${({theme}) => theme.getSize(1)};
`;
